import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ResponsiveService } from '@mmscan/design-system';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import { NavbarComponent } from './navbar/navbar.component';

@Component({
  selector: 'mp-layout',
  imports: [NavbarComponent, FooterComponent, LoaderComponent, RouterOutlet],
  templateUrl: './layout.component.html',
  providers: [],
})
export class LayoutComponent {
  responsiveService = inject(ResponsiveService);
}
